import React, { FC, useCallback, useState } from 'react';
import * as tokens from '@utmost.co/utmost-design-tokens';
import { SystemIconButton } from '../Icon/SystemIconButton';
import Drawer from '../Drawer/Drawer';
import { SideNavBar } from './SideNavBar';

export const MobileSideNavBar: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const [open, setOpen] = useState(false);

  const openDrawer = useCallback(() => setOpen(true), []);
  const closeDrawer = useCallback(() => setOpen(false), []);

  return (
    <div>
      <SystemIconButton
        dataTest="mobile-side-nav-btn"
        iconName="menu"
        onClick={openDrawer}
        color={tokens.colorOnBanner}
      />
      <Drawer anchor="left" onClose={closeDrawer} open={open}>
        <SideNavBar maxWidth="auto" localStorageKey="">
          {children}
        </SideNavBar>
      </Drawer>
    </div>
  );
};
